import React from 'react';
import { useTranslation } from 'react-i18next';
import CancelSubscriptionModal from './CancelSubscriptionModal';

export function CancelSubscriptionSection({ isFreeTrial }) {
    const { t } = useTranslation();

    if (isFreeTrial) {
        return null;
    }

    return (
        <div className="box" style={{ marginBottom: '1.5em' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1.1em'
            }}>
                <div>
                    <span style={{
                        fontFamily: 'Source Sans Pro, sans-serif',
                        fontWeight: 600,
                        fontSize: '0.87em',
                        color: '#4A4A4A'
                    }}>
                        {t('agency_subscription.cancel_subscription_label')}
                    </span>
                    <p style={{
                        margin: '0.2em 0 0',
                        color: '#B6B6B7',
                        fontSize: '0.87em',
                        fontFamily: 'Source Sans Pro, sans-serif'
                    }}>
                        {t('agency_subscription.cancel_subscription_description')}
                    </p>
                </div>
                <CancelSubscriptionModal />
            </div>
        </div>
    );
}
